import TableCellContent from './table-cell-content';

export default TableCellContent;